var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91856 19.9377C15.2205 19.9377 19.7613 13.0596 19.7613 7.09495C19.7613 6.89959 19.7613 6.70511 19.7481 6.51151C20.6315 5.87255 21.394 5.0814 22 4.17511C21.1763 4.54031 20.3024 4.7797 19.4075 4.88527C20.3498 4.32123 21.0551 3.43399 21.3919 2.38871C20.5059 2.91452 19.5366 3.28505 18.5258 3.48431C17.8452 2.76067 16.9452 2.2815 15.9648 2.12094C14.9845 1.96037 13.9786 2.12738 13.1028 2.59611C12.227 3.06483 11.53 3.80915 11.1198 4.71388C10.7097 5.61861 10.6091 6.6333 10.8337 7.60095C9.03915 7.51093 7.28361 7.04456 5.681 6.23211C4.07839 5.41967 2.66453 4.2793 1.5312 2.88503C0.954001 3.87869 0.777216 5.05499 1.03684 6.17442C1.29647 7.29385 1.97298 8.27224 2.92864 8.91039C2.2103 8.88934 1.50759 8.69556 0.88 8.34543V8.40263C0.880285 9.44474 1.24103 10.4547 1.90105 11.2611C2.56107 12.0676 3.47972 12.6209 4.5012 12.8273C3.83669 13.0085 3.13947 13.035 2.46312 12.9047C2.75166 13.8015 3.31323 14.5857 4.0693 15.1477C4.82538 15.7097 5.73817 16.0215 6.68008 16.0393C5.74424 16.7749 4.67254 17.3187 3.5263 17.6398C2.38006 17.9608 1.18178 18.0527 0 17.9102C2.06418 19.2348 4.46593 19.9374 6.91856 19.9342",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.84c6ba0ebc08755d4157fee6b8ab6b3e.svg";
export { ForwardRef as ReactComponent };